<div class="flex w-full flex-col items-end gap-2 rounded-b-2xl bg-gray-000 pb-1 shadow-xs" data-cy="portfolio-summary">
	<div class="flex w-full flex-col items-end justify-center px-3">
		<ui-divider tip="050" />
		<div class="flex w-full items-center py-1">
			<div class="flex min-w-0 flex-1 flex-col gap-0.5 text-right">
				<span class="text-xs text-gray-600 pt-2">دارایی کل بورس کالا</span>

				<div class="flex w-full items-center gap-0.5 text-base">
					@if (amountsHidden()) {
						<span class="font-black text-gray-900" data-cy="portfolio-summary-total-assets">
							{{ maskedValue }}
						</span>
					} @else {
						<ui-number
							format="1.0-0"
							dir="ltr"
							class="font-black tabular-nums text-gray-900"
							data-cy="portfolio-summary-total-assets"
							[value]="totalAssets()" />
					}
					<span class="text-gray-600">ریالءء</span>
				</div>
			</div>

			<ui-button
				variant="mute"
				model="fill"
				size="lg"
				data-cy="portfolio-summary-visibility-toggle"
				[iconOnly]="true"
				[label]="visibilityLabel()"
				[ariaPressed]="amountsHidden()"
				(clicked)="toggleAmounts()">
				<ui-icon leftIcon width="20" height="20" class="text-gray-600" [iconName]="visibilityIcon()" />
			</ui-button>
		</div>
	</div>

	<div class="flex w-full flex-col items-start gap-2 pb-1">
		<!-- tabindex makes the overflowing row reachable by keyboard, which axe's
		scrollable-region-focusable rule requires. -->
		<div
			#carousel
			tabindex="0"
			role="group"
			aria-label="خلاصه وضعیت پرتفوی"
			class="flex w-full items-center justify-start gap-2 overflow-x-auto px-3 scrollbar-none"
			data-cy="portfolio-summary-cards"
			(scroll)="onCarouselScroll()">
			@for (card of cards(); track card.dataCy; let index = $index) {
				<div
					#cardEl
					class="flex shrink-0 flex-col items-end justify-center gap-1.5 rounded-lg bg-stroke-050 p-3 font-medium"
					[style.width.px]="cardWidths()[index]">
					<span class="w-full text-right text-2.75 text-gray-500 text-nowrap">{{ card.label }}</span>

					<div
						class="flex w-full items-start gap-0.5 text-right text-sm"
						[class.text-gray-900]="card.isProfit === null"
						[class.text-green-500]="card.isProfit === true"
						[class.text-red-500]="card.isProfit === false">
						@if (amountsHidden()) {
							<span class="font-black text-gray-900" [attr.data-cy]="card.dataCy">
								{{ maskedValue }}
							</span>
						} @else {
							@if (card.percent) {
								<span dir="ltr" [attr.data-cy]="card.percentDataCy">{{ card.percent }}</span>
							}
							<ui-number
								format="1.0-0"
								dir="ltr"
								class="tabular-nums"
								[attr.data-cy]="card.dataCy"
								[value]="card.value" />
						}
						<span class="text-3.25 text-gray-500">ریالءء</span>
					</div>
				</div>
			}
		</div>

		@if (indicatorSegments().length) {
			<div class="flex w-full items-center justify-center gap-1" aria-hidden="true">
				@for (segment of indicatorSegments(); track segment) {
					<span
						class="h-1 rounded-xs bg-stroke-100 transition-all"
						[class.bg-gray-900!]="segment === activeSegment()"
						[class.w-4]="segment === activeSegment()"
						[class.w-1]="segment !== activeSegment()"></span>
				}
			</div>
		}
	</div>
</div>
